import * as PIXI from 'pixi.js'
import { tween } from 'popmotion'

const spriteFromImage = (url, width, height) => {
  // create ghost DOM element
  const domTextureImage = document.createElement('img')

  // define a promise, since we need to wait file load..
  const spritePromise = new Promise((resolve, reject) => {
    domTextureImage.addEventListener('load', () => {
      const { naturalWidth, naturalHeight } = domTextureImage

      // load texture
      const pixiBaseTexture = new PIXI.BaseTexture(domTextureImage)
      const texture = new PIXI.Texture(pixiBaseTexture)

      // put it into a sprite
      const spriteTexture = new PIXI.Sprite(texture)

      // center it
      spriteTexture.anchor.set(0.5)
      spriteTexture.x = naturalWidth / 2
      spriteTexture.y = naturalHeight / 2
      resolve(spriteTexture)
    })

    // start loading
    domTextureImage.setAttribute('src', url)
    // TODO: error handler
  })
  return spritePromise
}

const liquidTransition = (displacementFilter, { fromX, fromY, toX, toY, duration, easing }) => {
  return new Promise((resolve, reject) => {
    const liquidTween = tween({
      from: { x: fromX, y: fromY },
      to: { x: toX, y: toY },
      duration: duration,
      ease: easing
    })

    return liquidTween.start({
      update: ({ x, y }) => {
        displacementFilter.scale.x = x
        displacementFilter.scale.y = y
      },
      complete: resolve
    })
  })
}

const waveAnimation = (filterSprite, { horizontalSpread, verticalSpread }) => {
  const waveTween = tween({
    from: { x: 0, y: 0 },
    to: { x: horizontalSpread, y: verticalSpread },
    duration: 1.5,
    yoyo: Infinity
  })

  return waveTween.start(({ x, y }) => {
    filterSprite.x += x
    filterSprite.y += y
  })
}

export { spriteFromImage, liquidTransition, waveAnimation }
